import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {GSDevTools} from "gsap/GSDevTools";

export class CustomerJourneyTimeline {
  constructor(container) {
    this.container = container;
    this.items = container.querySelectorAll('.journey-timeline__item');
    this.avatar = container.querySelectorAll('.avatar');

    //gsap
    this.tl = undefined;
    this.gsapConfig = {
      debug: false,
      start: 'top 75%',
      end: 'top bottom',
    };

    this.initGsap();
  }

  /**
   * if desktop scrolltrigger, mobile overlays
   */
  initGsap() {
    gsap.registerPlugin(ScrollTrigger);

    this.initAvatarPin();
    this.tl = this.initTl();

    if (this.gsapConfig.debug) {
      gsap.registerPlugin(GSDevTools);
    }
  }

  initAvatarPin() {
    let end = "center top";

    ScrollTrigger.create({
      trigger: this.container,
      start: "top 75%-=50",
      end: "bottom 75%+=50",
      pin: this.avatar,
      pinSpacing: false,
      toggleClass: 'is-active'
    });
  }

  /**
   * step segment with avatar
   * @returns {*}
   */
  initTl() {
    let tl = gsap.timeline({
      id: 'timeline',
    });

    this.items.forEach((item, idx) => {
      tl.to(
        item,
        {
          scrollTrigger: {
            trigger: item,
            start: this.gsapConfig.start,
            end: this.gsapConfig.end,
            markers: this.gsapConfig.debug || false,
            scrub: true
          },
          opacity: 1
        }
      )
    });

    return tl;
  }
}

// initialize
const customerJourney = document.querySelectorAll('.journey-timeline__wrapper').forEach(container => {
  new CustomerJourneyTimeline(container)
})
